export { default } from '@/screens/AuthScreen';

